export default __webpack_public_path__ + "media/images/lp/hero_sp-a1f387b71ba7282a42ba52d730f961c0.png";